import { ApolloClient, gql, NormalizedCacheObject, useQuery } from "@apollo/client";
import { Query } from "../types/generated/graphql";

export const useGetOneYouTubeProfileHistory = (client: ApolloClient<NormalizedCacheObject>, id: string) => {
  type T = Pick<Query, 'getOneYouTubeProfileHistory'>;
  const ret = useQuery<T>(QUERY_GET_ONE_YOUTUBE_PROFILE_HISTORY, { 
    client, variables: { id },
    fetchPolicy: "network-only", // Always fetch from the server
  });

  return ret;
}

const QUERY_GET_ONE_YOUTUBE_PROFILE_HISTORY = gql`
  query fct($id: String!) {
    getOneYouTubeProfileHistory(id: $id) {
      profileId
      videos {
        # HistoryVideo fields
        id
        title
        description
        author {
          id
          name
        }
        thumbnails {
          url
          height
          width
        }
        duration
        snapshot_date
        watch_date
        watched_on
        is_watched
        is_live
        published
        view_count
        feedback {
          dontRecommendChannel {
            token
            undoToken
          }
          notInterested {
            token
            undoToken
          }
        }
      }
    }
  }
`;
